import React, { useState } from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import { periodoPorDefecto } from '../../common/formato-dashboard'

const MENSAJE_PERIODO_INVALIDO = 'La fecha de inicio debe ser anterior a la fecha de fin.'

const fechaCorta = (iso) => {
    const [anio, mes, dia] = iso.split('-')
    return `${dia}/${mes}/${anio}`
}

const FiltrosDashboard = ({ onAplicar, disabled }) => {
    const [periodo, setPeriodo] = useState(periodoPorDefecto())
    const [aplicado, setAplicado] = useState(periodo)
    const { periodoDesde, periodoHasta } = periodo
    const incompleto = !periodoDesde || !periodoHasta
    const invalido = !incompleto && periodoDesde > periodoHasta

    const handleChange = (e) => setPeriodo({ ...periodo, [e.target.name]: e.target.value })

    const aplicar = () => {
        if (incompleto || invalido) return
        setAplicado(periodo)
        onAplicar(periodo)
    }

    const limpiar = () => {
        const porDefecto = periodoPorDefecto()
        setPeriodo(porDefecto)
        setAplicado(porDefecto)
        onAplicar(porDefecto)
    }

    return (
        <Card>
            <Card.Body className='py-3'>
                <Form onSubmit={(e) => { e.preventDefault(); aplicar() }}>
                    <Row className='g-2 align-items-end'>
                        <Col xs={12} sm='auto'>
                            <Form.Label className='mb-0 small fw-semibold'>Desde</Form.Label>
                            <Form.Control type='date' name='periodoDesde' value={periodoDesde} max={periodoHasta || undefined} onChange={handleChange} isInvalid={invalido} />
                        </Col>
                        <Col xs={12} sm='auto'>
                            <Form.Label className='mb-0 small fw-semibold'>Hasta</Form.Label>
                            <Form.Control type='date' name='periodoHasta' value={periodoHasta} min={periodoDesde || undefined} onChange={handleChange} isInvalid={invalido} />
                        </Col>
                        <Col xs='auto'>
                            <Button type='submit' disabled={disabled || incompleto || invalido}>Aplicar</Button>
                        </Col>
                        <Col xs='auto'>
                            <Button variant='outline-secondary' disabled={disabled} onClick={limpiar}>Limpiar</Button>
                        </Col>
                        <Col xs='auto'>
                            <span className='border rounded px-2 py-1 small text-muted bg-light'>
                                Período: {fechaCorta(aplicado.periodoDesde)} – {fechaCorta(aplicado.periodoHasta)}
                            </span>
                        </Col>
                    </Row>
                    {invalido && <div className='text-danger small mt-1'>{MENSAJE_PERIODO_INVALIDO}</div>}
                </Form>
            </Card.Body>
        </Card>
    )
}
export default FiltrosDashboard
